export class Publication {
  public id?: number;
  public name: string;
  public description_next: string;
  public condition: string;
  public condition_next: string;
  public extra_name: string;
  public extra_name_next: string;
  public phone: string;
  public age: string;
  public description: string;
  public type: string;
  public has_paper_form: boolean;
  public preview: Preview;
  public thumbnail_image: Preview;
  public has_virtual_form: boolean;
  public amount_in_current_period: number;
  public sale_days_left: number;
  public price_from_in_current_period: number;
  public active_subscriptions: SubscriptionItem[];
  public next_subscriptions: SubscriptionItem[];
  public categories: Category[];
  public datetime: string;
  public is_sale_in_active_period?: boolean;
  public is_sale_in_next_period?: boolean;

  public get img() {
    return this.preview ? this.preview.path : '/assets/img/icons/newspaper.svg';
  }

  public get thImg() {
    return this.thumbnail_image ? this.thumbnail_image.path : this.img;
  }

  constructor(data?: Publication) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export interface Preview {
  path: string;
}

export class SubscriptionItem {
  public id: number;
  public index: number;
  public include_nds: number;
  public comment: string;
  public type: string;
  public is_outside: number;
  public is_sale: number;
  public amount: number;
  public period: number;
  public cost: number;
  public cost_with_delivery: number;
  public start_at: string;
  public user_type: string;
  public end_at: string;
  public without_months: number[];
  public parent: {
    id: number;
    index: number;
    cost: number;
    cost_with_delivery: number;
  };
}

export interface Category {
  id: number;
  name: string;
  type: string;
}
